import { IRequestNavClient } from "@/shared/model/global/request-nav-client.model";
import { IYmlConstants } from "@/shared/model/global/yml-constants.model";
import { INavClient } from "@/shared/model/nav-client.model";
import axios from "axios";
const baseApiUrl = "api/global";

export default class GlobalService {
  public getNavclient(entity: IRequestNavClient): Promise<INavClient> {
    return new Promise<INavClient>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/get-nav-client`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNavclientPublic(entity: any): Promise<INavClient> {
    return new Promise<INavClient>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/get-nav-client-public`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public postRecaptcha(event): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/recaptcha/` + event)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getYmlConstants() {
    return new Promise<IYmlConstants>(function (resolve, reject) {
      axios
        .get(`${baseApiUrl}/get-yml-constants`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getActiveProfiles() {
    return new Promise<any>(function (resolve, reject) {
      axios
        .get(`management/info`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
